<section class="flex flex-col h-screen">
    <div class="flex items-center justify-start pb-6 px-3 basis-1/12">
        <button
            class="p-2 border border-primary rounded-full mt-3"
            [routerLink]="authPath"
        >
            <svg class="w-4 h-4 fill-primary">
                <use href="../../../assets/svg/svGP.svg#chevron-left"></use>
            </svg>
        </button>
    </div>
    <div class="basis-3/12 p-6 pt-0">
        <div class="rounded-3xl bg-cover bg-center"
             style="background-image: url('../assets/img/background_video.png');">
            <video controls preload="metadata" class="m-auto basis-full max-h-96">
                <source src="../assets/video/presentazione.mp4" type="video/mp4">
            </video>
        </div>
    </div>
    <div class="custom-bg-white relative w-full py-5 px-4 rounded-t-4xl basis-8/12">
        <h1 class="text-primary font-semibold text-3xl">Accedi</h1>
        <span class="text-danger">{{ errorMessage }}</span>
        <p class="mt-3">
            Accedi alla tua area personale
        </p>
        <form [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
            <div class="flex flex-col mt-3.5">
                @if (shouldShowTestEmailSelector) {
                    <div class="rounded-2xl border border-light-grey bg-[#f7f8fa] p-4 mb-3">
                        <label
                            class="block text-sm font-bold text-primary"
                            for="testAccountSelect"
                        >
                            Account test
                        </label>
                        <select
                            id="testAccountSelect"
                            class="mt-2 py-3 px-4 border border-light-grey rounded-lg block w-full bg-white focus:ring-0 focus:border-primary"
                            [value]="selectedTestEmailIndex"
                            (change)="onTestEmailChange($any($event.target).value)"
                        >
                            @for (testEmail of testEmails; track testEmail.index) {
                                <option [value]="testEmail.index">
                                    {{ testEmail.label }}
                                </option>
                            }
                        </select>
                    </div>
                }
                <div class="relative mt-2.5">
                    <input
                        id="emailLabel"
                        class="py-5 px-4 border border-light-grey rounded-lg mt-6 block w-full bg-transparent appearance-none focus:ring-0 focus:border-primary peer"
                        type="email"
                        placeholder=""
                        formControlName="email"
                        autocomplete="username"
                    />
                    <label
                        for="emailLabel"
                        class="absolute text-9ea5b0 duration-300 transform -translate-y-2 scale-75 top-2 z-10 origin-[0] px-4 peer-focus:px-4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-2/3 peer-placeholder-shown:top-2/3 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-2 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >{{
                            "components.login-form.emailLabel" | transloco
                        }}</label
                    >
                </div>
                <!-- Gestione errore campo form email da stilizzare -->
                @if (loginForm.controls['email'].invalid &&
                loginForm.controls['email'].touched) {
                    <span class="text-danger text-sm"
                    >Per favore inserisci una email valida</span
                    >
                }
                <!-- Fine gestione errore campo email -->
                <div class="relative mt-2.5">
                    <input
                        id="passwordLabel"
                        class="py-5 px-4 border border-light-grey rounded-lg mt-6 block w-full bg-transparent appearance-none focus:ring-0 focus:border-primary peer"
                        [type]="showPassword ? 'text' : 'password'"
                        placeholder=""
                        formControlName="password"
                        autocomplete="current-password"
                    />
                    <svg class="absolute size-6 bottom-[20px] right-[20px] fill-primary cursor-pointer"
                         (click)="togglePassword()">
                        <use
                            [attr.href]="showPassword ? '../../../assets/svg/svGP.svg#password-hide' : '../../../assets/svg/svGP.svg#password'"></use>
                    </svg>
                    <label
                        for="passwordLabel"
                        class="absolute text-9ea5b0 duration-300 transform -translate-y-2 scale-75 top-2 z-10 origin-[0] px-4 peer-focus:px-4 peer-focus:text-primary peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-2/3 peer-placeholder-shown:top-2/3 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-2 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                    >{{
                            "components.login-form.passwordLabel" | transloco
                        }}</label
                    >
                </div>
                <!-- Gestione errore campo form password da stilizzare -->
                @if (loginForm.controls['password'].invalid &&
                loginForm.controls['password'].touched) {
                    <span class="text-danger text-sm"
                    >Per favore inserisci una password</span
                    >
                }
                <!-- fine  gestione errore campo form password -->
                <div
                    class="py-5 px-3 border-0 bg-white rounded-lg flex items-center justify-start"
                >
                    <a
                        class="flex items-center"
                        [routerLink]="resetPasswordPath"
                    >
                        <span class="text-primary text-sm font-bold">{{
                                "components.login-form.forgotPasswordLabel"
                                    | transloco
                            }}</span>
                    </a>
                </div>
                <button
                    class="py-5 px-4 border-0 bg-primary rounded-lg flex items-center justify-center mt-7"
                    type="submit"
                    [disabled]="loginForm.invalid || (isLoading$ | async)"
                >
                    <div class="flex items-center">
                        @if (isLoading$ | async) {
                            <span class="button-loader"></span>
                        } @else {
                            <span class="text-white text-sm font-bold uppercase">{{
                                    "components.login-form.loginLabel" | transloco
                                }}</span>
                        }
                    </div>
                </button>
                <div class="my-7 text-center">
                    <span>Oppure</span>
                </div>
                <a
                    class="py-5 px-4 border border-light-grey rounded-lg flex items-center justify-center mb-2.5"
                    href="{{ apiUrl }}{{ googleAuth }}"
                >
                    <div>
                        <svg class="w-4 h-4 translate-y-px me-2">
                            <use
                                href="../../../assets/svg/svGP.svg#google-logo"
                            ></use>
                        </svg>
                    </div>
                    <div>
                            <span
                                class="font-titillium text-sm font-bold uppercase"
                            >{{
                                    "components.login-form.loginWithGoogleLabel"
                                        | transloco
                                }}</span
                            >
                    </div>
                </a>
                <a
                    class="py-5 px-4 border border-light-grey rounded-lg flex items-center justify-center mb-2.5"
                    href="{{ apiUrl }}{{ appleAuth }}"
                >
                    <div>
                        <svg class="w-4 h-4 translate-y-px me-2">
                            <use
                                href="../../../assets/svg/svGP.svg#apple-logo"
                            ></use>
                        </svg>
                    </div>
                    <div>
                            <span
                                class="font-titillium text-sm font-bold uppercase"
                            >Accedi con apple</span
                            >
                    </div>
                </a>
            </div>
        </form>
    </div>
</section>
